export const environment = {
  production: false,
  APP_ID: '3a25eb8e-e553-485a-9b32-d46e19f74a9a',
  PROMO: "CH25B1",
  API_BASE_URL: '//localhost:4734/offers/api/acceleratorpromo',
  IMAGE_BASE_URL: 'http://localhost:4200/public/images/',
  ASSETS_BASE_URL: 'http://localhost:4200/public/images/',
};